import React from "react";
import { RiGolfBallLine } from "react-icons/ri";
import { ArrowRight, Flag } from "lucide-react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="relative h-[78vh] md:h-[80vh] bg-black text-white overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source
            src="https://res.cloudinary.com/dxdvcplbl/video/upload/v1772441265/banner_video_wy1jkz.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        {/* Gradient Overlay */}
        {/* <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-emerald-900/60 to-lime-900/40"></div> */}
      </div>

      {/* Floating Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-8 animate-float">
          <div className="w-6 h-6 rounded-full bg-gradient-to-r from-emerald-400/20 to-lime-400/20 backdrop-blur-sm border border-emerald-400/30"></div>
        </div>
        <div className="absolute top-20 right-12 animate-float-delayed">
          <div className="w-5 h-5 rounded-full bg-gradient-to-r from-lime-400/20 to-emerald-400/20 backdrop-blur-sm border border-lime-400/30"></div>
        </div>
        <div className="absolute bottom-20 left-16 animate-float-slow">
          <div className="w-8 h-8 rounded-full bg-gradient-to-r from-emerald-400/20 to-lime-400/20 backdrop-blur-sm border border-emerald-400/30"></div>
        </div>
      </div>

      {/* Main Content - Centered with more compact layout */}
      <div className="relative z-10 h-full flex items-center justify-center px-4 md:px-8">
        <div className="max-w-6xl w-full text-center md:text-left">
          {/* Welcome Badge - Smaller */}
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-lime-500/20 backdrop-blur-sm border border-emerald-400/30">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-500 to-lime-500 flex items-center justify-center">
              <RiGolfBallLine className="w-4 h-4 text-white" />
            </div>
            <span className="text-sm font-semibold text-emerald-200 tracking-wide">
              WELCOME TO RGCC
            </span>
          </div>

          {/* Main Heading - Adjusted sizes */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
            Where{" "}
            <span className="relative inline-block">
              <span className="relative z-10 bg-gradient-to-r from-emerald-300 via-lime-300 to-emerald-300 bg-clip-text text-transparent">
                Excellence
              </span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-500/30 to-lime-500/30 -rotate-1"></span> */}
            </span>{" "}
            Meets Passion
            <br />
            <span className="text-3xl md:text-5xl lg:text-6xl text-emerald-100">
              on Every Green
            </span>
          </h1>

          {/* Sub Heading - Smaller */}
          <h2 className="text-xl md:text-2xl text-emerald-100 mb-8 max-w-2xl mx-auto md:mx-0 leading-relaxed">
            A premier destination for the discerning golfers
          </h2>

          {/* Action Buttons - Smaller padding */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center md:justify-start">
            <Link
              to="/membership"
              className="group relative px-8 py-4 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 text-black font-bold overflow-hidden transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <span className="relative z-10 flex items-center justify-center gap-2 text-base">
                <span className="uppercase tracking-wide">Get Membership</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
            </Link>

            <Link
              to="/golf-course"
              className="group px-8 py-4 rounded-full border-2 border-emerald-400 text-emerald-300 font-bold hover:bg-emerald-400/10 hover:scale-105 transition-all duration-500 shadow-lg hover:shadow-xl"
            >
              <span className="flex items-center justify-center gap-2">
                <Flag className="w-4 h-4" />
                <span>Explore Course</span>
              </span>
            </Link>
          </div>

          {/* Features Grid - More compact */}
          {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto md:mx-0">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <Star className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">9-Hole</div>
                <div className="text-xs text-emerald-200">Championship</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <Trophy className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">70+</div>
                <div className="text-xs text-emerald-200">Tournaments</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <MapPin className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">Riverside</div>
                <div className="text-xs text-emerald-200">Location</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">Premium</div>
                <div className="text-xs text-emerald-200">Amenities</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Scroll Indicator - Smaller */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-emerald-400/30 flex items-center justify-center">
          <div className="w-1 h-4 bg-gradient-to-b from-emerald-400 to-lime-400 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

// import React, { useState, useEffect } from "react";
// import { RiGolfBallLine } from "react-icons/ri";
// import { ArrowRight, Flag } from "lucide-react";
// import { Link } from "react-router-dom";

// const HeroSection = () => {
//   const [videosLoaded, setVideosLoaded] = useState(false);
//   const [activeVideo, setActiveVideo] = useState(0);

//   // Two video sources with their background types
//   const videoSources = [
//     {
//       src: "https://res.cloudinary.com/dxdvcplbl/video/upload/v1771854477/rggc_intro_video_espe1p.mp4",
//       type: "intro",
//       bgType: "light", // This video has light background
//     },
//     {
//       src: "https://res.cloudinary.com/dxdvcplbl/video/upload/v1772441265/banner_video_wy1jkz.mp4",
//       type: "banner",
//       bgType: "dark", // This video has dark background
//     },
//   ];

//   useEffect(() => {
//     // Preload both videos
//     const preloadVideos = async () => {
//       const promises = videoSources.map((video) => {
//         return new Promise((resolve) => {
//           const videoElement = document.createElement("video");
//           videoElement.src = video.src;
//           videoElement.onloadeddata = resolve;
//         });
//       });

//       await Promise.all(promises);
//       setVideosLoaded(true);
//     };

//     preloadVideos();

//     // Rotate videos every 8 seconds
//     const interval = setInterval(() => {
//       setActiveVideo((prev) => (prev + 1) % videoSources.length);
//     }, 8000);

//     return () => clearInterval(interval);
//   }, []);

//   // Manual video switch handlers
//   const handleVideoChange = (index) => {
//     setActiveVideo(index);
//   };

//   // Determine if current video has light background
//   const isLightBackground = videoSources[activeVideo].bgType === "light";

//   return (
//     <section className="relative h-[78vh] md:h-[80vh] bg-black text-white overflow-hidden">
//       {/* Video Background Container */}
//       <div className="absolute inset-0">
//         {/* Primary Video */}
//         <video
//           key={videoSources[0].src}
//           autoPlay
//           loop
//           muted
//           playsInline
//           className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
//             activeVideo === 0 ? "opacity-100" : "opacity-0"
//           }`}
//         >
//           <source src={videoSources[0].src} type="video/mp4" />
//         </video>

//         {/* Secondary Video */}
//         <video
//           key={videoSources[1].src}
//           autoPlay
//           loop
//           muted
//           playsInline
//           className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
//             activeVideo === 1 ? "opacity-100" : "opacity-0"
//           }`}
//         >
//           <source src={videoSources[1].src} type="video/mp4" />
//         </video>
//       </div>

//       {/* Video Indicator Dots */}
//       <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 z-20 flex gap-2">
//         {videoSources.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => handleVideoChange(index)}
//             className={`w-2 h-2 rounded-full transition-all duration-300 ${
//               activeVideo === index
//                 ? "w-8 bg-emerald-500"
//                 : isLightBackground
//                   ? "bg-gray-600 hover:bg-gray-800"
//                   : "bg-white/50 hover:bg-white/80"
//             }`}
//             aria-label={`Switch to video ${index + 1}`}
//           />
//         ))}
//       </div>

//       {/* Floating Decorative Elements - Dynamic colors based on background */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute top-10 left-8 animate-float">
//           <div
//             className={`w-6 h-6 rounded-full bg-gradient-to-r backdrop-blur-sm border ${
//               isLightBackground
//                 ? "from-emerald-600/30 to-lime-600/30 border-emerald-600/40"
//                 : "from-emerald-400/20 to-lime-400/20 border-emerald-400/30"
//             }`}
//           ></div>
//         </div>
//         <div className="absolute top-20 right-12 animate-float-delayed">
//           <div
//             className={`w-5 h-5 rounded-full bg-gradient-to-r backdrop-blur-sm border ${
//               isLightBackground
//                 ? "from-lime-600/30 to-emerald-600/30 border-lime-600/40"
//                 : "from-lime-400/20 to-emerald-400/20 border-lime-400/30"
//             }`}
//           ></div>
//         </div>
//         <div className="absolute bottom-20 left-16 animate-float-slow">
//           <div
//             className={`w-8 h-8 rounded-full bg-gradient-to-r backdrop-blur-sm border ${
//               isLightBackground
//                 ? "from-emerald-600/30 to-lime-600/30 border-emerald-600/40"
//                 : "from-emerald-400/20 to-lime-400/20 border-emerald-400/30"
//             }`}
//           ></div>
//         </div>
//       </div>

//       {/* Loading Indicator */}
//       {!videosLoaded && (
//         <div className="absolute inset-0 flex items-center justify-center bg-black z-30">
//           <div className="w-16 h-16 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
//         </div>
//       )}

//       {/* Main Content - Dynamic text colors based on background */}
//       <div className="relative z-10 h-full flex items-center justify-center px-4 md:px-8">
//         <div className="max-w-6xl w-full text-center md:text-left">
//           {/* Welcome Badge - Dynamic */}
//           <div
//             className={`inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full backdrop-blur-sm border ${
//               isLightBackground
//                 ? "bg-gradient-to-r from-emerald-500/40 to-lime-500/40 border-emerald-600/50"
//                 : "bg-gradient-to-r from-emerald-500/20 to-lime-500/20 border-emerald-400/30"
//             }`}
//           >
//             <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-500 to-lime-500 flex items-center justify-center">
//               <RiGolfBallLine className="w-4 h-4 text-white" />
//             </div>
//             <span
//               className={`text-sm font-semibold tracking-wide ${
//                 isLightBackground ? "text-gray-800" : "text-emerald-200"
//               }`}
//             >
//               WELCOME TO RGCC
//             </span>
//           </div>

//           {/* Main Heading - Dynamic */}
//           <h1
//             className={`text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 transition-colors duration-500 ${
//               isLightBackground ? "text-gray-900" : "text-white"
//             }`}
//           >
//             Where{" "}
//             <span className="relative inline-block">
//               <span className="relative z-10 bg-gradient-to-r from-emerald-600 to-lime-600 bg-clip-text text-transparent">
//                 Excellence
//               </span>
//             </span>{" "}
//             Meets Passion
//             <br />
//             <span
//               className={`text-3xl md:text-5xl lg:text-6xl transition-colors duration-500 ${
//                 isLightBackground ? "text-gray-800" : "text-emerald-100"
//               }`}
//             >
//               on Every Green
//             </span>
//           </h1>

//           {/* Sub Heading - Dynamic */}
//           <h2
//             className={`text-xl md:text-2xl mb-8 max-w-2xl mx-auto md:mx-0 leading-relaxed transition-colors duration-500 ${
//               isLightBackground ? "text-gray-700" : "text-emerald-100"
//             }`}
//           >
//             A premier destination for the discerning golfers
//           </h2>

//           {/* Action Buttons - Dynamic */}
//           <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center md:justify-start">
//             <Link
//               to="/membership"
//               className={`group relative px-8 py-4 rounded-full font-bold overflow-hidden transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl ${
//                 isLightBackground
//                   ? "bg-gradient-to-r from-emerald-600 to-lime-600 text-white"
//                   : "bg-gradient-to-r from-emerald-500 to-lime-500 text-black"
//               }`}
//             >
//               <div
//                 className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${
//                   isLightBackground
//                     ? "bg-gradient-to-r from-emerald-700 to-lime-700"
//                     : "bg-gradient-to-r from-emerald-400 to-lime-400"
//                 }`}
//               ></div>
//               <span className="relative z-10 flex items-center justify-center gap-2 text-base">
//                 <span className="uppercase tracking-wide">Get Membership</span>
//                 <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
//               </span>
//             </Link>

//             <Link
//               to="/golf-course"
//               className={`group px-8 py-4 rounded-full border-2 font-bold hover:scale-105 transition-all duration-500 shadow-lg hover:shadow-xl ${
//                 isLightBackground
//                   ? "border-emerald-600 text-emerald-700 hover:bg-emerald-600/10"
//                   : "border-emerald-400 text-emerald-300 hover:bg-emerald-400/10"
//               }`}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 <Flag className="w-4 h-4" />
//                 <span>Explore Course</span>
//               </span>
//             </Link>
//           </div>
//         </div>
//       </div>

//       {/* Scroll Indicator - Dynamic */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce">
//         <div
//           className={`w-8 h-12 rounded-full border-2 flex items-center justify-center ${
//             isLightBackground
//               ? "border-emerald-600/40"
//               : "border-emerald-400/30"
//           }`}
//         >
//           <div
//             className={`w-1 h-4 bg-gradient-to-b rounded-full animate-pulse ${
//               isLightBackground
//                 ? "from-emerald-600 to-lime-600"
//                 : "from-emerald-400 to-lime-400"
//             }`}
//           ></div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;
